import React, { useState, useCallback } from "react";
import { isMobile,  useMobileOrientation } from 'react-device-detect'

import '../css/loader.css'

export default function Loader({ loaded, onRunApp }) {

      // Pause video when a mobile device is in portrait orientation
  const { isPortrait } = useMobileOrientation();
  const titleClassName = isMobile ? "mobile-title" : "browser-title";
  const submissionClassName = isMobile ? "submission submission-mobile" : "submission submission-browser";

  const [isStarting, setIsStarting] = useState(false)
  
  
  // tour = true also starts the guided tour once the app is showing
  const handleStartApp = useCallback((tour) => {
    if (!loaded || isStarting) return
    setIsStarting(true)
    setTimeout(() => {
      onRunApp(tour)
      setIsStarting(false)
    }, 250)
  }, [loaded, isStarting, onRunApp])
    
  const renderLoader = () => {
    return (
      <div className="container-flex loader">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12 text-center">
            <h1 className={titleClassName}>KINO</h1>
              <div>
                <div className={submissionClassName}>
                  <button
                    type="button"
                    className={`btn-loader btn-loader-text${loaded ? '' : ' transparent'}`}
                    disabled={!loaded || isStarting}
                    onClick={() => handleStartApp(false)}
                  >
                    ENTER
                  </button>
                  <button
                    type="button"
                    className={`btn-loader btn-loader-text${loaded ? '' : ' transparent'}`}
                    disabled={!loaded || isStarting}
                    onClick={() => handleStartApp(true)}
                  >
                    TAKE THE TOUR
                  </button>
                </div>
                { !isMobile && (
                  <div className={"contributors"}>
                    <p className={"contributor-title"}>CONTRIBUTORS</p>
                    <p className={"contributor-name"}>ROBERT MANTEGHI</p>
                    <p className={"contributor-name"}>TED JOHANSSON</p>
                  </div>
                )}
              </div>
          </div>
        </div>
      </div>
    );
  }

  const renderRotate = () => {
    return (
      <div className="container-flex loader">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12 text-center">
            <h1 className={titleClassName}>KINO</h1>
              <div>
              <p className="rotate-helper-text">PLEASE <br/>ROTATE TO <br/>LANDSCAPE</p>
              { !isMobile && (
                <div className={"contributors"}>
                    <p className={"contributor-title"}>CONTRIBUTORS</p>
                    <p className={"contributor-name"}>ROBERT MANTEGHI</p>
                    <p className={"contributor-name"}>TED JOHANSSON</p>
                  </div>
              )}
              </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    {(isMobile && isPortrait) ? renderRotate() : null}
    { !isMobile || !isPortrait ? renderLoader() : null}
    </>
  );
}
